<template>
  <div id="login">    
    <div class="page-single">
      <div class="container">
        <div class="row">
          <div class="col col-login mx-auto">
            <div class="text-center mb-6">
              <a href="#"><img src="static/img/logo_blk.png" alt="Membership Logo" width="100"></a>
            </div>
            <form @submit.prevent="checkCreds" class="card">
              <div class="card-body p-6">
                <div class="card-title">Login to e-MemberS</div>
                <!-- <div role="alert" class="alert alert-icon alert-primary alert-dismissible">
                  <button data-dismiss="alert" class="close"><span class="glyphicon glyphicon-bell"></span></button>
                  <i aria-hidden="true" class="fe fe-bell mr-2"></i>
                  {{response}}
                </div>                 -->
                <div class="alert alert-icon alert-primary alert-dismissible" v-if="response != ''">
                  {{response}}
                </div>
                <div class="form-group">
                  <label class="form-label">User</label>
                  <input v-model="username" type="email" tabindex="1" name="username" aria-describedby="emailHelp" placeholder="Email" class="form-control">
                </div>
                <div class="form-group">
                  <label class="form-label">Password<a href="/recover" class="float-right small">I forgot the password</a></label>
                  <input v-model="password" type="password" tabindex="1" name="password" placeholder="Password" class="form-control">
                </div>
                <div class="form-footer">
                  <button type="submit" class="btn btn-danger btn-block">
                    <span v-if="loadingSubmit"><i class="icon ion-spinner fa-spin"></i> Login...</span>
                    <span v-else>Login</span>
                  </button>
                </div>
              </div>
            </form>
            <!-- <div class="text-center text-muted">Don't have account yet?<a href="/register">Sign up</a></div>                         -->
            <div class="text-center text-muted">Copyright &copy; 2019 Sinarmas Land</div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import api from '../api'
import config from '../config'
// import SweetAlert from 'sweetalert2'
// import ClientHub from '../signalr/clienthub'
// import Vue from 'vue'

export default {
  name: 'Login',
  data(router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: '',
      loadingSubmit: false
    }
  },
  methods: {
    getImageUrl(id) {
      return api.getBaseUrl('Guest', '/api/Guest/GetImage?Id=' + id)
    },
    checkCreds() {
      this.loadingSubmit = true
      const { username, password } = this

      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      var data
      api
        .request('Account', 'post', '/api/Account/Login', { EmailAddress: username, Password: password })
        .then(response => {
          this.loadingSubmit = false
          this.toggleLoading()

          data = response.data
          /* Checking if error object was returned from the server */
          if (!data.isAuthenticated) {
            this.response = data.returnMessage.join('<br>')
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.isAuthenticated) {
            var token = 'Bearer ' + data.token
            var tokenValidAt = new Date().setMinutes(new Date().getMinutes() + config.sessionTimeout)

            this.$store.commit('SET_USER', data.entity)
            this.$store.commit('SET_TOKEN', token)
            this.$store.commit('SET_TOKEN_VALID_AT', tokenValidAt)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(data.entity))
              window.localStorage.setItem('token', token)
              window.localStorage.setItem('tokenValidAt', tokenValidAt)
            }
          }
        })
        .then(response => {
          this.loadingSubmit = false
          if (data.isAuthenticated) {
            this.$router.push(data.redirect ? data.redirect : '/admin/dashboard')
          }
        })
        .then(response => {
          this.loadingSubmit = false
          if (data.isAuthenticated) {
            // ClientHub.install()
            // this.$clientHub.$on('check-in-confirmation', this.onCheckInConfirmation)
          }
        })
        .catch(error => {
          this.loadingSubmit = false
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)

          this.response = 'Server appears to be offline'
          this.toggleLoading()
        })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    }
    // // This is called from the server through SignalR
    // onCheckInConfirmation ({ guest, projectId, guestActivityId }) {
    //   var guestName = []
    //   if (guest.firstName) {
    //     guestName.push(guest.firstName)
    //   }
    //   if (guest.lastName) {
    //     guestName.push(guest.lastName)
    //   }

    //   let membershipStatus = guest.amount === '0' ? 'Active' : 'Inactive'
    //   // let locationId = window.localStorage.getItem('locationId')

    //   SweetAlert.fire({
    //     title: 'Please confirm this guest to do check-in process ?',
    //     html: '<h3 style="color:red; font-weight:bold;">' + guestName.join(' ') + '</h3> <br>' + '<img src="' + this.getImageUrl(guest.id) + '" class="img-responsive img-thumbnail" style="max-height:200px;max-width:200px;">' +
    //           '<br> <h4 style="color:blue;">Membership: ' + guest.membershipName + '</h4>' +
    //           '<br> <h3 style="color:red;margin:0px;">' + membershipStatus + '</h3>',
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Continue',
    //     cancelButtonText: 'Cancel',
    //     showCloseButton: true,
    //     showLoaderOnConfirm: true
    //   })
    //   .then((result) => {
    //     if (result.value) {
    //       this.checkInConfirmation(guestActivityId)
    //     } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
    //       SweetAlert.fire('Cancelled', 'The guest still not check-in', 'info')
    //     }
    //   })
    // },
    // checkInConfirmation(guestActivityId) {
    //   var status = 'success'
    //   var message = ''
    //   var reqData = {
    //     Id: guestActivityId
    //   }
    //   api
    //     .request('Guest', 'post', '/api/Guest/CheckInConfirmation', reqData)
    //     .then(response => {
    //       var resData = response.data
    //       status = resData.returnStatus ? 'success' : 'error'
    //       message = resData.returnMessage.join('<br>')

    //       SweetAlert.fire(status, message, status)
    //     })
    //     .catch(error => {
    //       var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
    //       SweetAlert.fire('Error', message, 'error')
    //     })
    // }
  }
}
</script>

<style scoped>
.page {
  flex-direction: column;
  justify-content: center;
  min-height: calc( 100vh - 65px - 55px - 67px);  
}
.page-single {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
}
.container {
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1200px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}
.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.col-login {
  max-width: 42rem;
}
.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.text-center {
  text-align: center !important;
}
.mb-6 {
  margin-bottom: 2rem !important;
}
.card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  margin-bottom: 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 40, 100, 0.12);
  border-radius: 3px;  
}
.card-body {
  flex: 1 1 auto;
  margin: 0;
  padding: 1.5rem 1.5rem;
  position: relative;
}
.p-6 {
  padding: 2rem !important;
}
.card-title {
  font-size: 2.125rem;
  line-height: 1.2;
  font-weight: 400;
  margin-bottom: 1.5rem;
}
.form-label {
  display: block;
  margin-bottom: .375rem;
  font-weight: 600;
  font-size: 1.6rem;
}
.float-right {
  float: right !important;
}
small,
.small {
  font-size: 87.5%;
  font-weight: 400;
}
.form-footer {
  margin-top: 2rem;
}
.btn {
  cursor: pointer;
  font-weight: 600;
  letter-spacing: .03em;
  font-size: 1.4rem;
  min-width: 1.375rem;
}
.btn-primary {
  color: #fff;
  background-color: #45aaf2;
  border-color: #45aaf2;
}
.btn-block {
  display: block;
  width: 100%;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 3px;
}
.alert-icon {
  padding-left: 3rem;
}
.alert-icon > i {
  color: inherit !important;
  font-size: 1rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}
/* .alert-primary {
  color: #24426c;
  background-color: #dae5f5;
  border-color: #cbdbf2;
} */
.alert-primary {
  color: #fff;
  background-color: #ef0e3c;
  border-color: #ef0e3c;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}
.fe-bell:before {
  content: "\e91d";
}
.fe {
  font-family: 'feather' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.close {
  font-size: 1rem;
  line-height: 1.5;
  transition: .3s color;
}

.close:before {
  content: '\ea00';
  font-family: "feather";
}
</style>



// WEBPACK FOOTER //
// Login.vue?f10a22e6